const initialState = {
  sideBarMobile: false,
};

const HeaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SIDEBAR_OPENER":
      return {
        ...state,
        sideBarMobile: action.payload,
      };
    default:
      return state;
  }
};

export default HeaderReducer;
